import { render, staticRenderFns } from "./ProfileDash.vue?vue&type=template&id=0ab49052&scoped=true&"
import script from "./ProfileDash.vue?vue&type=script&lang=js&"
export * from "./ProfileDash.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDash.vue?vue&type=style&index=0&id=0ab49052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab49052",
  null
  
)

export default component.exports